import { apiClient } from './client';
import type { Category } from '../types';

export const categoriesApi = {
  list: async () => {
    const res = await apiClient.get('/categories');
    return res.data.data.categories as Category[];
  },

  create: async (data: { name: string; description?: string; color?: string; icon?: string; sortOrder?: number }) => {
    const res = await apiClient.post('/categories', data);
    return res.data.data.category as Category;
  },

  update: async (id: string, data: Partial<Category>) => {
    const res = await apiClient.put(`/categories/${id}`, data);
    return res.data.data.category as Category;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/categories/${id}`);
  },
};
